import React from 'react';
import ThemeToursTemplate from './ThemeToursTemplate';

const Honeymoon = () => {
  return <ThemeToursTemplate theme="honeymoon" />;
};

export default Honeymoon;
